import { datetime } from "colbi_web_ui/lib/utils";
import { camelize } from "../../utils/camelize";

export const RepositoryStatusEnum = {
    merge_requested: "merge_requested",
    calculating_tribal: "calculating_tribal",
    calculating_kpis: "calculating_kpis",
    calculating_merge: "calculating_merge",
    test_running: "test_running",
    done: "done",
    error: "error",
};

export const prepareGeneratedFileByStatus = (status) => {
    switch (status) {
        case "error":
            return {
                severity: "3",
                family: "error",
            };
        case "merge_requested":
        case "calculating_tribal":
        case "calculating_kpis":
        case "calculating_merge":
            return {
                severity: "1",
                family: "warning",
            };
        case "test_running":
            return {
                label: "running_rules",
                severity: "1",
                family: "warning",
            };
        case "done":
            return {
                severity: "0",
                family: "success",
            };
        default:
            return {
                severity: "1",
                family: "warning",
            };
    }
};

export const mapCard = (json) => {
    const { id, status, createdAt, updatedAt, fileType, filesIds, fiscalYear } = json;
    const { severity, family, label } = prepareGeneratedFileByStatus(status);
    return [
        [
            {
                labels: ["id"],
                value: id,
                type: "string",
            },
        ],
        [{ labels: ["fiscalYear"], value: fiscalYear, type: "string" }],
        [
            {
                labels: ["fileType"],
                value: fileType,
                type: "string",
            },
        ],

        [
            {
                labels: ["filesIds"],
                value: filesIds,
                type: "string",
            },
        ],
        [
            {
                labels: ["status"],
                value: {
                    label: camelize((label || status).replace("_", " ")),
                    severity,
                    family,
                    color: "main",
                },
                type: "fileStatus",
            },
        ],
        [
            {
                labels: ["createdAt"],
                value: datetime(createdAt),
                type: "datetime",
            },
        ],
        [
            {
                labels: ["updatedAt"],
                value: datetime(updatedAt),
                type: "datetime",
            },
        ],
    ];
};

const mapper = (json, card) => {
    return {
        ...json,
        name: json.name,
        shortName: json.name,
        card: card ? mapCard(json) : [],
    };
};

const header = [
    {
        label: ["Identifier"],
        align: "left",
        columnName: "id",
        sortable: true,
    },
    {
        label: ["Fiscal Year"],
        align: "left",
        columnName: "fiscalYear",
        sortable: true,
    },
    {
        label: ["File Type"],
        align: "left",
        columnName: "fileType",
        sortable: true,
    },
    {
        label: ["File Ids"],
        align: "center",
        columnName: "filesIds",
    },
    {
        label: ["Status"],
        align: "center",
        columnName: "status",
        sortable: true,
        type: "fileStatus",
    },
    {
        label: ["Created At"],
        align: "center",
        columnName: "createdAt",
        sortable: true,
    },
    {
        label: ["Updated At"],
        align: "center",
        columnName: "updatedAt",
        sortable: true,
    },
];

const mergeHistoryMapper = {
    map: mapper,
    header,
};

export default mergeHistoryMapper;
